import React from 'react'
import { useParams } from 'react-router';

// collection
import PDFGenerator from './PDFGenerator/PDFGenerator.collection';

// wrapper
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// gql
import { GET_JOB_DAY_INFO_FOR_PDF } from '../../../graphql/jobDay/jobDay.queries';

const GenerateTimeTicketPDF = () => {

    const { jobDayId } = useParams()

    return (<div>
        <WithGqlQuery component={PDFGenerator} query={GET_JOB_DAY_INFO_FOR_PDF} variables={{ id: jobDayId}} />
    </div>)
}

export default GenerateTimeTicketPDF;